module.exports = __webpack_public_path__ + "img/xuanxing_banner_es.a70c833b.jpg";